module.exports = __webpack_public_path__ + "static/media/walkie-talkie.0dd110c8.svg";